import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { IEventListItem } from "../../models/event/eventListItem";
import { ListLine } from "../framework/listLine";
import { EventListStateCol } from "ui/Scripts/source/components/event/eventListStateCol";

//EventListLine
export interface IEventListLineProp {
    item: IEventListItem;
    selected: boolean;
    first: boolean;
    isLastOpenedEvent: boolean;
    onClick: (id: string) => void;
    onLongPress: (id: string) => void;
    onRefreshList: () => void;
}

export class EventListLine extends React.Component<IEventListLineProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        if (item.isTitle) {
            return (
                <ListLine
                    id={item.id}
                    first={props.first}
                    selected={false}
                    classes={"line dataTitle" + (item.titleClass ? " " + item.titleClass : "")}
                    onClick={(id: string) => {}}
                    onLongPress={(id: string) => {}}
                    onRefreshList={props.onRefreshList}>
                    <div className="row">
                        <div className="col col-12">{item.name}</div>
                    </div>
                </ListLine>
            );
        }
        return (
            <ListLine
                id={item.id}
                first={props.first}
                selected={props.selected}
                classes={"line es s" + item.state.toString(10) + (props.selected ? " selected" : "") + (props.isLastOpenedEvent ? " loe" : "")}
                onClick={props.onClick}
                onLongPress={props.onLongPress}
                onRefreshList={props.onRefreshList}>
                <div className="row">
                    <div className="col col-9 bold">{item.name}</div>
                    <div className="col col-3 ra">{Base.timeToDateStr(item.date)}</div>
                </div>
                <div className="row sub">
                    <div className="col col-6">{(item.userCompanyName ? item.userCompanyName + " / " : "") + item.userName}</div>
                    <div className="col col-6"><EventListStateCol item={item} reverse={true} /></div>
                </div>
            </ListLine>
        );
    }
}